import { useDispatch } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { StoreState } from "./StoreState";

export type ReduxDispatch = ThunkDispatch<StoreState, any, Action>;
export function useReduxDispatch() {
  return useDispatch<ReduxDispatch>();
}
